module.exports = __webpack_public_path__ + "static/media/image_48.dc8d79fe.png";